export const holdOptions = [
  "CustomerUnreachable",
  "ChargerFaulty",
  "ItemMissing",
  "CustomerRequest",
  "DealerRequest",
  "OtherReason"
].map((item) => ({ key: item, label: item.replace(/([A-Z])/g, " $1").trim(), value: item }));

export const cancelOptions = [
  "CustomerUnreachable",
  "CustomerRefused",
  "Duplicate",
  "DealerRequest",
  "NoShow",
  "IncorrectUpload",
  "OtherReason"
].map((item) => ({ key: item, label: item.replace(/([A-Z])/g, " $1").trim(), value: item }));

export const cancelComplaintOptions = [
  "CustomerUnreachable",
  "ProblemResolvedOverPhone",
  "DuplicateComplaintUploaded",
  "IncorrectUpload",
  "OtherReason"
].map((item) => ({ key: item, label: item.replace(/([A-Z])/g, " $1").trim(), value: item }));

export const closeComplaintOptions = [
  { value: "BurntWireReplaced", label: "Burnt wire replaced" },
  { value: "ChargerToBeReplaced", label: "Charger to be replaced" },
  { value: "EVSEOEMNeedsToInspectTheCharger", label: "EVSE OEM needs to inspect the charger" },
  {
    value: "EmergencyButtonWasPressedNowRectified",
    label: "Emergency button was pressed, now rectified"
  },
  {
    value: "EarthingValueToBeRectifiedByTheCustomer",
    label: "Earthing value to be rectified by the customer"
  },
  { value: "FaultCodesWereRemovedAndNowOk", label: "Fault codes were removed and now ok" },
  { value: "MCBWasTrippedNowOk", label: "MCB was tripped now ok" },
  { value: "MCBReplaced", label: "MCB replaced" },
  { value: "NewEarthingToBeDoneByCustomer", label: "New earthing to be done by customer" },
  {
    value: "NewRFIDToBeObtainedByCustomerFromConcernedSupplier",
    label: "New RFID to be obtained by the customer from the concerned supplier"
  },
  {
    value: "NewChargerKeyToBeObtainedByCustomerFromConcerned",
    label: "New charger key to be obtained by the customer from the concerned"
  },
  {
    value: "PhaseVoltagesToBeRectifiedByDISCOM",
    label: "Phase voltages to be rectified by DISCOM"
  },
  { value: "RCBOReplaced", label: "RCBO replaced" },
  { value: "RedLightIssueResolved", label: "Red light issue resolved" },
  { value: "RCBOWasTrippedNowOk", label: "RCBO was tripped now ok" },
  {
    value: "SoftwareUpdationDoneChargerIsWorkingNow",
    label: "Software updation done charger is working now"
  },
  { value: "OthersReasons", label: "Others reasons" }
];

export const OldInstallTypeOptions = [
  { value: "installation_complete", label: "Type 1" },
  { value: "installation_pending", label: "Type 2" },
  { value: "reinstall", label: "Reinstall" },
  { value: "uninstall", label: "Uninstall" },
  { value: "replacement", label: "Replacement" }
];

export const installTypeOptions = [
  { value: "installation_complete", label: "Type 1" },
  { value: "installation_pending", label: "Type 2" }
];

export const natureOfWorkOptions = [
  { value: "new_installation", label: "New Installation" },
  { value: "new_installation_second_charger", label: "New Installation (2nd Charger)" },
  { value: "reinstallation", label: "Reinstallation" }
];

export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

export const categoryOptions = [
  { value: "category_one", label: "Cat-1" },
  { value: "category_two", label: "Cat-2" },
  { value: "category_three", label: "Cat-3" }
];


export const userTypeOptions = [
  { value: "ecb", label: "ECB" },
  { value: "external", label: "EXTERNAL" },
  { value: "client", label: "ClIENT" }
];

export const yesNoNaOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
  { value: null, label: "NA" },
];

export const completionStatusOptions = [
  { value: "completed", label: "Completed" },
  { value: "pending", label: "Pending" },
  { value: "na", label: "NA" }
];

export const customerBillingOptions = [
  { value: true, label: "Client/OEM paid" },
  { value: false, label: "Customer/Dealer paid" }
];

export const BankNameOptions = [
  { value: "Kotak Mahindra Bank", label: "Kotak Mahindra Bank" },
  { value: "HDFC Bank", label: "HDFC Bank" }
];

export const reportTypeOptions = [
  { value: "installations", label: "IR Master" },
  { value: "database", label: "Database 1" },
  { value: "database_recent_new", label: "Database - Recently Updated (New)" },
  { value: "complaints_database", label: "Complaints Database" },
  { value: "invoicing_installation", label: "Invoicing Reports Installations" },
  { value: "invoicing_survey", label: "Invoicing Reports Surveys" },
  { value: "client_database", label: "Client Database" }
];

export const financeReportOptions = [
  { value: "payment_tracker", label: "Payment Tracker" },
  { value: "payment_tracker_recent", label: "Payment Tracker Recently Updated" },
  { value: "msil_survey", label: "MSIL Survey Master" },
  { value: "msil_installation", label: "MSIL Installation Master" }
];

export const adminReportTypeOptions = [
  { value: "msil_dealer", label: "MSIL Dealer Master" },
  { value: "msil_booking_change", label: "MSIL Booking Change" }
];

export const clientReportOptions = [
  { value: "client_database", label: "Database" },
  { value: "client_complaints_database", label: "Complaints Database" }
];

export const broadSurveeyFinding1Options = [
  "Apply for Power Load Enhancement",
  "Get some civil work done, which is not in SOW for installation package",
  "Site is good to go for installation",
  "Apply for some permissions from local bodies to carry out the installation of chargers",
  "Other"
].map((item) => ({ id: item, name: item }));

export const broadVisitFinding1Options = [
  "Earthing fault",
  "Voltage parameters are not proper",
  "Charger has physical damage",
  "MCB box has physical damage",
  "RCBO box has physical damage",
  "Connection wires are burnt",
  "Charger internal issue",
  "RFID lost",
  "Emergency button is not working/ broken",
  "RCBO is not working",
  "Charger key lost",
  "Others"
].map((item) => ({ id: item, name: item }));

export const broadSurveeyFinding2Options = [
  "Site is good to go for installation",
  "Commissioning will be done after load enhancement"
].map((item) => ({ id: item, name: item }));

export const logTypeOptions = [
  { value: "call_me_later", label: "Call me later" },
  { value: "cancelled_the_booking", label: "Cancelled the booking" },
  { value: "cee_customer_ready_for_survey", label: "CEE- Customer ready for survey" },
  {
    value: "customer_already_has_an_ev_charger_and_does_not_want_another_charger_installation",
    label: "Customer already has an EV charger and does not want another charger installation"
  },
  {
    value: "customer_did_not_purchase_any_charger_package",
    label: "Customer did not purchase any charger package"
  },
  { value: "customer_refused", label: "Customer refused" },
  { value: "customer_scope_of_working_pending", label: "Customer scope of working pending" },
  { value: "customer_wants_installation_later", label: "Customer wants installation later" },
  {
    value: "installation_already_done_by_another_partner",
    label: "Installation already done by another partner"
  },
  { value: "not_picked", label: "Not picked" },
  { value: "noc_not_provided_by_society", label: "NOC not provided by society" },
  { value: "outstation_approval_awaited", label: "Outstation approval awaited" },
  {
    value: "payment_for_extra_cable_is_pending",
    label: "Payment for extra cable is pending"
  },
  { value: "scheduled", label: "Scheduled" },
  { value: "site_house_under_construction", label: "Site / House under construction" },
  { value: "site_is_good_to_go_for_installation", label: "Site is good to go for installation" },
  {
    value: "survey_installation_done_against_another_survey_booking_no",
    label: "Survey installation done against another survey booking no"
  },
  {
    value: "survey_installation_done_against_other_charger_package",
    label: "Survey installation done against other charger package"
  },
  {
    value: "survey_installation_done_under_other_dealer",
    label: "Survey installation done under other dealer"
  },
  { value: "switched_off", label: "Switched off" },
  { value: "wants_survey_later", label: "Wants survey later" },
  { value: "any_other_reason", label: "Any other reason" }
];

export const logTypeComplaintOptions = [
  { value: "call_me_later", label: "Call me later" },
  {
    value: "customer_not_available_and_asked_to_call_later",
    label: "Customer not available and asked to call later"
  },
  { value: "problem_resolved_over_phone", label: "Problem resolved over phone" },
  { value: "switched_off", label: "Switched off" },
  { value: "vehicle_is_not_available", label: "Vehicle is not available" },
  { value: "visit_planned", label: "Visit planned" },
  { value: "any_other_reason", label: "Any other reason" }
];

export const siteReadinessStatusOptions = [
  { value: "site_readiness_good", label: "Site readiness is good" },
  { value: "site_readiness_not_good", label: "Site readiness is not good" },
  { value: "site_readiness_partial_good", label: "Site readiness is partial good" }
]

export const chargerTypeOptions = [
  { value: "na", label: "NA" },
  { value: "kva11", label: "KVA11" },
  { value: "kva22", label: "KVA22" },
  { value: "3.3kw", label: "3.3 kW" },
  { value: "7.2kw", label: "7.2 kW" },
  { value: "7.4kw", label: "7.4 kW" },
  { value: "11kw", label: "11 kW" },
  { value: "22kw", label: "22 kW" }
];

export const EMAIL_TYPES: any = {
  seek_payment_email: "Seek Payment Email",
  refund_processed_email: "Refund Processed Email",
  refund_email: "Refund Email"
};
